import type { ValueOf } from '../util/typeUtils';

export const CORPORATION_RESOLVERS = {
    get: 'get',
    getCorporationByDirectorId: 'getCorporationByDirectorId',
    getOwnCorporation: 'getOwnCorporation',
    isDirectorOfThisCorporation: 'isDirectorOfThisCorporation',
    list: 'list',
} as const;

export type CORPORATION_RESOLVER = ValueOf<typeof CORPORATION_RESOLVERS>;
